"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var context_1 = require("../../../context");
var FormControl_1 = __importDefault(require("../../FormControl"));
var Input_1 = __importDefault(require("../../Input"));
var FirstNameInput = function () {
    var trans = context_1.useSemantics().trans;
    var errors = formik_1.useFormikContext().errors;
    return (react_1.default.createElement(FormControl_1.default, { errors: errors.first_name, dusk: "first-name-field", label: trans('optiiva::labels.first-name') },
        react_1.default.createElement(Input_1.default, { dusk: "first-name", name: "first_name", maxLength: 100 })));
};
exports.default = FirstNameInput;
//# sourceMappingURL=FirstNameInput.js.map